import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { RootState } from '@/app/store'
import backToMapImage from '@/assets/images/onoff/back-to-map.png'
import besallaIcon from '@/assets/images/onoff/besalla-just-icon.svg'
import brandManager, { GIMI_BRAND } from '@/services/brandManager'

export interface OnOffTenantHeaderProps {
  /** Restaurant map URL. Defaults to brandManager.getRestaurantMapUrl(language) */
  mapUrl?: string
}

const OnOffTenantHeader: React.FC<OnOffTenantHeaderProps> = ({
  mapUrl,
}) => {
  const { t } = useTranslation()
  const { settings } = useSelector((state: RootState) => state.settings)
  const isRTL = settings.language === 'ar'
  const resolvedMapUrl = mapUrl ?? brandManager.getRestaurantMapUrl(settings.language)
  const isOnOffBrand = brandManager.currentBrand === GIMI_BRAND

  useEffect(() => {
    if (!isOnOffBrand) {
      return
    }

    document.body.classList.add('besalla-branded-tenant')
    return () => {
      document.body.classList.remove('besalla-branded-tenant')
    }
  }, [isOnOffBrand])

  if (!isOnOffBrand) {
    return null
  }

  return (
    <div className="besalla-tenant-header" dir={isRTL ? 'ltr' : 'rtl'}>
      <div className="besalla-tenant-header__banner">
        <img
          src={backToMapImage}
          alt=""
          className="besalla-tenant-header__image"
        />
        <span
          className="besalla-tenant-header__gradient"
          aria-hidden="true"
        />
        <div
          className="besalla-tenant-header__frame"
          aria-hidden="true"
        />
        <a
          href={resolvedMapUrl}
          className="besalla-tenant-header__back"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="besalla-tenant-header__content">
            <img
              src={besallaIcon}
              alt="Besalla"
              className="besalla-tenant-header__logo"
            />
            <span className="besalla-tenant-header__copy">
              <span className="besalla-tenant-header__arrow" aria-hidden="true">
              ↑
              </span>
            
              <span className="besalla-tenant-header__label">
                {t('tenant.back_to_map')}
              </span>
            </span>
          </span>
        </a>
      </div>
    </div>
  )
}

export default OnOffTenantHeader
